export default __webpack_public_path__ + "static/media/prdB2Line.4d3a3505.svg";